import './stopQr.scss';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function StopQrSkeleton() {
  return (
    <div className='stop-qr-main'>
      <Skeleton duration={0.5} className='stop-qr-skeleton-left'/>
      <div className='stop-qr-skeleton'>
        <Skeleton duration={0.5} className='stop-qr-skeleton-item'/>
        <div className='panel-recurso-stop-qr'>
          <Skeleton height={80} duration={0.5} className='stop-qr-skeleton-item'/>
          <Skeleton duration={0.5} className='stop-qr-skeleton-item'/>
        </div>
      </div>
    </div>
  );
}
